import {useEffect} from "react";
import {useGetPayrollEmployeesUploadTemplateLazyQuery} from "../../../__generated__/generated_types";
import {base64ToBlob, downloadDataAsFile} from "../../../utils/file-helpers";

export function useFetchPayrollEmployeesUploadTemplate() {
    const [getTemplate, {loading, data}] = useGetPayrollEmployeesUploadTemplateLazyQuery({
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        if (!loading && data?.getPayrollEmployeesUploadTemplate) {
            const blob = base64ToBlob(data.getPayrollEmployeesUploadTemplate.base64ZipFile, "application/zip");
            downloadDataAsFile(blob, "payroll_employees_upload_template.zip");
        }
    }, [loading, data]);

    const fetchTemplate = () => {
        getTemplate({
            variables: {
                format: "json"
            }
        });
    };

    return {fetchTemplate};
}
